import React from "react";
import {
  Navigate,
} from "react-router-dom";
import TrackingPost from "../../../components/tracking-post/components/show/page";




export const trackingPost = [
  {
      path: 'show',
      element: <TrackingPost />,
  },
  {
      path: '',
      element: <Navigate replace to="/tracking-post/show" />
  },
];